import { useSelector } from 'react-redux'
import { allOptionsSelector } from '~/store/api/options'

export function useGetOptionById(optionId: number) {
  const options = useSelector(allOptionsSelector)
  return options.find((currentOption) => currentOption.optionId === optionId)
}
